import React, { useState, useEffect } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import CommonTextField from "presentational/common/CommonTextField";
import TXT from "presentational/common/multinational/TXT";
import Typography from "@material-ui/core/Typography";
import { removeSpaceFromText } from "lib/commonUtil";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const MAX_LENGTH_OF_WHO = 200;
const MAX_LENGTH_OF_WHERE = 200;
const MAX_LENGTH_OF_WHAT = 200;
const MAX_LENGTH_OF_ETC = 400;

const css = {
  paper: {
    marginLeft: 0,
    marginRight: 0,
    width: "90%"
  }
};

const WarningTypography = withStyles({
  root: {
    fontSize: 12
  }
})(Typography);

OutfitNoteInputModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  who: PropTypes.string,
  where: PropTypes.string,
  what: PropTypes.string,
  etc: PropTypes.string,
  onMemoSubmit: PropTypes.func.isRequired
};

function OutfitNoteInputModalView(props) {
  const { open, onClose, who, where, what, etc, onMemoSubmit } = props;
  const [tempWho, setTempWho] = useState("");
  const [tempWhere, setTempWhere] = useState("");
  const [tempWhat, setTempWhat] = useState("");
  const [tempEtc, setTempEtc] = useState("");

  useEffect(() => {
    setTempWho(who || "");
    setTempWhere(where || "");
    setTempWhat(what || "");
    setTempEtc(etc || "");
  }, [who, where, what, etc]);

  const getMaxLength = type => {
    let maxLength;
    switch (type) {
      case "who":
        maxLength = MAX_LENGTH_OF_WHO;
        break;
      case "where":
        maxLength = MAX_LENGTH_OF_WHERE;
        break;
      case "what":
        maxLength = MAX_LENGTH_OF_WHAT;
        break;
      case "etc":
        maxLength = MAX_LENGTH_OF_ETC;
        break;

      default:
        console.error(`wrong type : "${type}"`);
        break;
    }
    return maxLength;
  };

  const cutExceedText = (type, inputText) => {
    if (typeof inputText !== "string") return "";
    const maxLength = getMaxLength(type);
    return inputText.length > maxLength
      ? inputText.slice(0, maxLength)
      : inputText;
  };

  const handleChange = type => e => {
    const { value } = e.target;
    if (getMaxLength(type) < value.length) return null;

    switch (type) {
      case "who":
        setTempWho(value);
        break;
      case "where":
        setTempWhere(value);
        break;
      case "what":
        setTempWhat(value);
        break;
      case "etc":
        setTempEtc(value);
        break;

      default:
        console.error(`wrong type : "${type}"`);
        break;
    }
  };

  const handleSaveBtnClick = () => {
    let whoV2 = removeSpaceFromText(tempWho);
    let whereV2 = removeSpaceFromText(tempWhere);
    let whatV2 = removeSpaceFromText(tempWhat);
    let etcV2 = removeSpaceFromText(tempEtc);

    whoV2 = cutExceedText("who", whoV2);
    whereV2 = cutExceedText("where", whereV2);
    whatV2 = cutExceedText("what", whatV2);
    etcV2 = cutExceedText("etc", etcV2);

    onMemoSubmit({
      who: whoV2,
      where: whereV2,
      what: whatV2,
      etc: etcV2
    });

    setTempWho(whoV2);
    setTempWhere(whereV2);
    setTempWhat(whatV2);
    setTempEtc(etcV2);

    onClose();
  };

  return (
    <CommonModalView
      open={open}
      onClose={onClose}
      paperStyle={css.paper}
      titleText={<TXT name="titleModal_writeOutfitMemo" />}
      contentComponent={
        <div>
          <div>
            <WarningTypography>
              <TXT name="msg_doNotSavePassword" />
            </WarningTypography>
          </div>
          <CommonTextField
            label={<TXT name="wordPlaceholder_outfitWho" />}
            value={tempWho}
            shrinkLabel
            errorText={
              getMaxLength("who") <= tempWho.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("who")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_outfitWhere" />}
            value={tempWhere}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("where") <= tempWhere.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("where")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_outfitWhat" />}
            value={tempWhat}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("what") <= tempWhat.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("what")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_outfitEtc" />}
            value={tempEtc}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("etc") <= tempEtc.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("etc")}
            margin="normal"
          />
        </div>
      }
      firstButtonText={<TXT name="btnModal_cancel" />}
      firstButtonFunc={onClose}
      secondButtonText={<TXT name="btnModal_save" />}
      secondButtonFunc={handleSaveBtnClick}
    />
  );
}

export default OutfitNoteInputModalView;
